<script setup>
import {Link} from "@inertiajs/vue3";
import {route} from "ziggy-js";
</script>

<template>
    <div class="w-full px-2.5 md:px-0 md:max-w-[640px] m-auto">
        <Link :href="route('products.index')"
              class="mt-5 px-4 py-4 bg-deep-blue flex items-center gap-3 rounded-lg transition-opacity hover:opacity-80">
            <span class="shrink-0" style="width: 28px; height: 28px">
                <ion-icon name="bag-handle" style="width: 28px; height: 28px" class="text-cyan-400"></ion-icon>
            </span>
            <span class="font-sans text-white text-sm">
                {{ $t('We also sell game items from players: accounts, currency, skins - with a deal guarantee.') }}
            </span>
        </Link>
    </div>
</template>
